/* src/app/components/risk-management/risk-management.component.css */
/*# sourceMappingURL=risk-management.component.css.map */
